<template>
  <div class="container">
    <h1 class="text-center h1">{{ $tc("message.products.title") }}</h1>
    <!-- <carousel-3d :autoplay="true" :autoplay-timeout="5000" ref="mycarousel" :count="slides.length" :height="348" :width="195.5">
          <slide v-for="(slide, i) in slides" :index="i" :key="slide.id">
            <div id="box-reflect">
              <img :src="slide.image">
            </div>
          </slide>
      </carousel-3d> -->
    <!-- <div>
      <b-row>
        <b-col md="8" offset-md="2">
          <img class="img" src="@/assets/images/home-products_logo.png" />
        </b-col>
      </b-row>
    </div> -->

    <b-row align-h="center" style="margin-top: 80px;">
      <b-col cols="12">
        <div>
          <swiper :options="swiperOption" class="text-center div-swiper">
            <swiper-slide v-for="(slide, index) of swiperArray" :key="index">
              <img
                class="img"
                :src="require('../../../assets/images/' + slide + '.png')"
              />
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </b-col>
    </b-row>

    <b-row class="b-row">
      <template v-for="(item, index) in products.type">
        <b-col v-bind:key="index" md="2" offset-md="0">
          <button class="button-wrapper" @click="goToSlide(item)">
            {{ item.title }}
          </button>
        </b-col>
      </template>
    </b-row>
    <div class="height-div"></div>
    <ModuleDetailAll v-show="false" ref="moduleDetailAll"></ModuleDetailAll>
  </div>
</template>

<script>
import ModuleDetailAll from "../../module/components/ModuleDetailAll";

import { products } from "@/js/infoData.js";
export default {
  name: "HomeContentProducts",
  components: {
    ModuleDetailAll
  },
  data() {
    return {
      itemData: {},
      products: [],
      swiperArray: [
        "product_image2",
        "product_image1",
        "product_image3",
        "product_image4"
      ],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 30,
        // slidesPerGroup: 3,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      slides: [
        {
          id: 0,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 1,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 2,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 3,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 4,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 5,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 6,
          image: "@/assets/images/phone_ad.png"
        },
        {
          id: 7,
          image: "@/assets/images/phone_ad.png"
        }
      ]
    };
  },
  mounted() {
    this.products = products;
  },

  methods: {
    goToSlide(item) {
      this.$router.push("/module");
      // setTimeout(() => {
      //   this.itemData = item;
      //   this.$refs.moduleDetailAll.showDetail(item);
      // }, 1600);
    }
  }
};
</script>

<style lang="stylus" scoped>
.h1 {
  padding-top: 5rem;
  color: #333333;
  font-size: 1.9rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 0.9rem;
  letter-spacing: 0rem;
}

// .img {
  // margin-top: 5rem;
  // width: 100%;
// }

.b-row {
  // margin-top: -15rem;

  .button-wrapper {
    margin-top: 1.1rem;
    width: 10.3rem;
    height: 4.1rem;
    background-color: #fff;
    box-shadow: 0rem 0.1rem 1.3rem 0rem rgba(4, 0, 0, 0.19);
    border-radius: 0.6rem;
  }
}

.height-div {
  height: 10rem;
}

.div-swiper {
  margin-bottom: 3rem;
}

.img {
  width: 100%;
  height: 350px;
  background-size: 100% 100%;
}

.swiper-button-prev {
  // background: url('../../assets/images/company-content-swiper-prev.png');
  width: 2.8rem;
  height: 2.7rem;
}

.swiper-button-prev:before {
  background: url('../../../assets/images/company-content-swiper-prev.png');
}

.swiper-button-next {
  // background: url('@/assets/images/company-content-swiper-next.png');
  width: 2.8rem;
  height: 2.7rem;
}

.swiper-button-next:before {
  background: url('../../../assets/images/company-content-swiper-next.png');
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentProducts.vue